import React from "react";
import { howItWorksData } from "../../data/mockData";

const HowItWorksSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-sky-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            {howItWorksData.title}
          </h3>
          <p className="text-lg text-slate-600">{howItWorksData.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {howItWorksData.steps.map((step) => (
            <div key={step.id} className="text-center space-y-4">
              <div className="w-20 h-20 bg-sky-600 text-white rounded-full flex items-center justify-center text-3xl font-bold mx-auto shadow-lg">
                {step.number}
              </div>
              <h4 className="text-2xl font-bold text-slate-900">
                {step.title}
              </h4>
              <p className="text-slate-600 text-lg">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
